import { X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/** Champ PIN numérique masqué, réutilisé par les formulaires du code Configuration. */
export function PinField({
  label,
  value,
  onChange,
  autoFocus,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  autoFocus?: boolean;
}) {
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <Input
        type="password"
        inputMode="numeric"
        autoFocus={autoFocus}
        data-allow-autofocus={autoFocus ? '' : undefined}
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))}
        className="font-mono"
        maxLength={10}
      />
    </div>
  );
}

export function PinError({ error }: { error: string | null }) {
  if (!error) return null;
  return (
    <p className="flex items-center gap-1.5 text-sm text-destructive">
      <X className="h-3.5 w-3.5" /> {error}
    </p>
  );
}
